function getAPI() {
  // let baseUrl = "https://store-locater.bilipatra.com/storelocate/"; //Live
  // let baseUrl = "http://3.108.43.136:3007/storelocate/"; //Dev
  // let baseUrl = "http://localhost:8084/storelocate/"; //Local
  let baseUrl =
    process.env.REACT_APP_BASE_URL || "https://store-locater.bilipatra.com/storelocate/";
  let dashboard = {
    displayNotes: `${baseUrl}employee_detail/v1/getemployeewiseorder`,
    editNotes: `${baseUrl}notes/apiUpdate`,
    deleteNotes: `${baseUrl}notes/apiDelete`,
    getOrderTotals: `${baseUrl}retailcounter_order/v1/TotalOrderReport`,
  };

  let designation = {
    insertNotes: `${baseUrl}notes/apiInsert`,
  };

  let configuration = {
    apiselect: `${baseUrl}configuration/v1/apiselect`,
  };

  let authenticate = {
    login: `${baseUrl}employee_detail/v1/login`,
    storeLogin: `${baseUrl}store_detail/v1/login`,
  };

  let order = {
    createOrder: `${baseUrl}retailcounter_order/v1/apiinsert`,
    createBranchOrder: `${baseUrl}retailcounter_order/v1/apibranchinsert`,
    orderSelectPagination: `${baseUrl}retailcounter_order/v1/apiselect`,
    deleteOrder: `${baseUrl}retailcounter_order/v1/delete`,
  };

  let orderlist = {
    paginatedOrderList: `${baseUrl}retailcounter_order/v1/orderlist`,
    orderListById: `${baseUrl}/retailcounter_order/v1/orderlistbyid`,
    deleteOrder: `${baseUrl}retailcounter_order/v1/delete`,
    createOrder: `${baseUrl}retailcounter_order/v1/apiinsert`,
  };

  let storelist = {
    storelist_all: `${baseUrl}store_detail/v1/apiselection`,
    allocateorder: `${baseUrl}order_payment_detail/v1/allocateorder`,
    resendOTP: `${baseUrl}store_detail/v1/resendOTP`,
  };

  let store = {
    add: `${baseUrl}store_detail/v1/apiinsert`,
    edit: `${baseUrl}store_detail/v1/apiupdate`,
    delete: `${baseUrl}store_detail/v1/apidelete`,
    list: `${baseUrl}store_detail/v1/apiselection`,
    select: `${baseUrl}store_detail/v1/apiselect`,
    changePassword: `${baseUrl}store_detail/v1/changepassword`,
  };

  let customer = {
    customerListPagination: `${baseUrl}retailcounter_customer/v1/apiselect`,
    customerInsert: `${baseUrl}retailcounter_customer/v1/apiinsert`,
  };

  // 🟢 NEW: Product related API endpoints
  // 🟢 UPDATED: Product related API endpoints matching retail_product_detail.ctrl.js
  let products = {
    // Assuming the router is mounted at /retail_product_detail in your main app.js/index.js
    productSelectAll: `${baseUrl}retail_product_detail/v1/retail_apiselectall`,
    productInsert: `${baseUrl}retail_product_detail/v1/retail_apiinsert`,
    productUpdate: `${baseUrl}retail_product_detail/v1/retail_apiupdate`,
    productDelete: `${baseUrl}retail_product_detail/v1/retail_apidelete`,
    productSelection: `${baseUrl}retail_product_detail/v1/retail_apiselection`, // If you need the dropdown version later
  };

  let freeOffers = {
    getAll: `${baseUrl}free_product_offers/getOffers`,
    add: `${baseUrl}free_product_offers/addOffer`,
    update: `${baseUrl}free_product_offers/updateOffer`,
    remove: `${baseUrl}free_product_offers/deleteOffer`,
  };

  let configList = {
    getAll: `${baseUrl}configuration/v1/apiselection`,
    updateBatch: `${baseUrl}configuration/updateBatch`,
  };

  let master = {
    display: dashboard.displayNotes,
    create: designation.insertNotes,
    edit: dashboard.editNotes,
    delete: dashboard.deleteNotes,

    // (Note: deliveryBoyList, deliveryBoyAadharAdd, etc. were undefined in your customer object,
    // leaving them as they were mapped in your original file)
    deliveryBoyList: customer.deliveryBoyList,
    customerListPagination: customer.customerListPagination,
    customerInsert: customer.customerInsert,
    deliveryBoyAadharAdd: customer.deliveryBoyAadharAdd,
    deliveryBoyAdd: customer.deliveryBoyAdd,
    deliveryBoyEdit: customer.deliveryBoyEdit,
    deliveryBoyDelete: customer.deliveryBoyDelete,

    paginatedOrderList: orderlist.paginatedOrderList,
    orderListById: orderlist.orderListById,
    deleteOrder: orderlist.deleteOrder,
    createOrder: orderlist.createOrder,
    createBranchOrder: order.createBranchOrder,
    updateorder: orderlist.updateorder,
    updateorderAdmin: orderlist.updateorderAdmin,

    config: configuration.apiselect,
    login: authenticate.login,
    storeLogin: authenticate.storeLogin,

    storelist_all: storelist.storelist_all,
    allocatestore: storelist.allocateorder,
    resendOTP: storelist.resendOTP,

    cancelorder: orderlist.cancelorder,
    orderundo: orderlist.orderundo,
    allocatedeliveryboy: orderlist.allocatedeliveryboy,
    getOrderTotals: dashboard.getOrderTotals,

    // Store APIs
    storeAdd: store.add,
    storeEdit: store.edit,
    storeDelete: store.delete,
    storeListPaginated: store.list,
    storeSelect: store.select,
    storeChangePassword: store.changePassword,

    // 🟢 NEW: Mapped Product APIs
    productSelectAll: products.productSelectAll,
    productInsert: products.productInsert,
    productUpdate: products.productUpdate,
    productDelete: products.productDelete,

    // 🟢 Invoice Backend APIs
    generateInvoicePdf: `${baseUrl}invoice/generate-invoice-pdf`,
    previewInvoiceHtml: `${baseUrl}invoice/internal-invoice-preview`,

    // 🟢 Free Product Offers APIs
    freeOfferGetAll: freeOffers.getAll,
    freeOfferAdd: freeOffers.add,
    freeOfferUpdate: freeOffers.update,
    freeOfferDelete: freeOffers.remove,

    // 🟢 Configuration APIs
    configGetAll: configList.getAll,
    configUpdateBatch: configList.updateBatch,

    // 🎁 Gift Eligibility Check (proxied via store-locator to avoid cross-origin CORS issues)
    checkNewCustomer: `${baseUrl}retailcounter_order/v1/get-customer-order-details`,
  };

  return { master };
}

export default getAPI;

